export const PrintReceiptPosCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Stampa ricevuta POS',
    path: '/sportello/stampa-ricevuta-pos',
  },
];
